import { useState } from 'react'
import styles from './WeeklyShortlist.module.css'
import LeftSidebar from './components/LeftSidebar'
import ShortlistContent from './components/ShortlistContent'
import ActionsPage from '../../ActionsPage/ActionsPage'

const WeeklyShortlist = () => {
    const [activeTab, setActiveTab] = useState('shortlist')

    return (
        <div className={styles.container}>
            <LeftSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
            <div className={styles.mainContent}>
                {activeTab === 'shortlist' ? <ShortlistContent /> : <ActionsPage />}
            </div>
        </div>
    )
}

export default WeeklyShortlist
